import { Trans } from '@lingui/macro'
import { useWeb3React } from '@web3-react/core'
import { RowBetween } from 'components/Row'
import { useState } from 'react'
import { ThemedText } from 'theme/components/text'

import GovernanceTabs, { GovernanceTab } from './components/GovernanceTabs'
import NetworkIndicator from './components/NetworkIndicator'
import { ConnectWalletMessage, ContentWrapper, PageWrapper, TitleWrapper } from './styleds'
import APRCalculatorTab from './tabs/APRCalculatorTab'
import HydraChainTab from './tabs/HydraChainTab'
import HydraDelegationTab from './tabs/HydraDelegationTab'
import HydraStakingTab from './tabs/HydraStakingTab'
import PriceOracleTab from './tabs/PriceOracleTab'
import VaultRewardsTab from './tabs/VaultRewardsTab'

export default function Governance() {
  const { account } = useWeb3React()
  const [activeTab, setActiveTab] = useState<GovernanceTab>('hydrachain')

  const renderTabContent = () => {
    switch (activeTab) {
      case 'hydrachain':
        return <HydraChainTab />
      case 'staking':
        return <HydraStakingTab />
      case 'delegation':
        return <HydraDelegationTab />
      case 'apr':
        return <APRCalculatorTab />
      case 'oracle':
        return <PriceOracleTab />
      case 'vault':
        return <VaultRewardsTab />
      default:
        return <HydraChainTab />
    }
  }

  return (
    <PageWrapper>
      <ContentWrapper>
        <TitleWrapper>
          <RowBetween>
            <ThemedText.LargeHeader>
              <Trans>Governance Admin</Trans>
            </ThemedText.LargeHeader>
            <NetworkIndicator />
          </RowBetween>
        </TitleWrapper>

        <GovernanceTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {!account ? (
          <ConnectWalletMessage>
            <Trans>
              Connect your wallet to interact with governance contracts. Read functions are available without
              connection.
            </Trans>
          </ConnectWalletMessage>
        ) : null}

        {renderTabContent()}
      </ContentWrapper>
    </PageWrapper>
  )
}
